export const VINYL_CAROUSEL_SETTINGS = {
	duration: 1000,
	mouseSpeed: 0.00075,
	mouseSpeedZones: [
		{ scope: [0, 0.04], factor: 0 },
		{ scope: [0.04, 0.44], factor: 2 },
		{ scope: [0.44, 0.84], factor: 4 },
		{ scope: [0.84, 1], factor: 20 },
	],
	desktopRotation: 48,
	mobileRotation: 80,
	mobileGap: 0.3,
	mobileZAdjoin: 1.4,
};
export const MOBILE_BREAKPOINT = 769;
